
import React from 'react';
import UserHeader from './UserHeader';
import AdminHeader from './AdminHeader';
import { HeaderContainer } from '../styled';

const Header = ({
  isAdmin, config, selectedKPIConfig, isEditable, selectedKPIConfigID, closeEditPopup, pageType, isSPIPopupOpen,
}) => {
  if (isAdmin && !pageType) {
    return (
      <HeaderContainer>
        <AdminHeader
          config={config}
          selectedKPIConfig={selectedKPIConfig}
          isEditable={isEditable}
          selectedKPIConfigID={selectedKPIConfigID}
          closeEditPopup={closeEditPopup}
          isSPIPopupOpen={isSPIPopupOpen}
        />
      </HeaderContainer>
    );
  }
  return (
    <HeaderContainer>
      <UserHeader
        config={config}
        selectedKPIConfig={selectedKPIConfig}
        selectedKPIConfigID={selectedKPIConfigID}
      />
    </HeaderContainer>
  );
};

export default Header;
